export default {
  buttons: {
    back: 'Back',
  },
};
